import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

const footerNav = [
  { label: 'News', href: '/#news' },
  { label: 'Suppliers', href: '/suppliers-directory' },
  { label: 'Market Data', href: '/market-data-page' },
  { label: 'FDA Tracker', href: '/fda-guidance-tracker-page' },
  { label: 'Advertise', href: '/advertise-page' },
  { label: 'About Us', href: '/about' },
];

const legalLinks = [
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Terms of Use', href: '/terms' },
  { label: 'Editorial Standards', href: '/editorial-standards' },
  { label: 'Sign In', href: '/sign-in' },
  { label: 'Manage Alerts', href: '/alerts' },
];

export default function Footer() {
  return (
    <footer style={{ backgroundColor: 'var(--footer-bg)' }} className="text-white">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pb-8 border-b border-white/10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <AppLogo size={32} />
              <span className="font-extrabold text-white text-lg tracking-tight">
                USA PEPTIDE PROS
              </span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed max-w-xs">
              Independent intelligence platform covering the U.S. peptide research and supply industry. Regulatory developments, supply chain news, testing standards, and market data.
            </p>
            <p className="mt-3 text-xs text-white/40">
              For informational and research purposes only. No medical or dosing advice provided.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <p className="text-xs font-700 uppercase tracking-widest text-white/40 mb-4">Coverage</p>
            <ul className="space-y-2">
              {footerNav?.map((link) => (
                <li key={`footer-nav-${link?.label}`}>
                  <Link
                    href={link?.href}
                    className="text-sm text-white/70 hover:text-white transition-colors duration-150"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <p className="text-xs font-700 uppercase tracking-widest text-white/40 mb-4">Legal & Account</p>
            <ul className="space-y-2">
              {legalLinks?.map((link) => (
                <li key={`footer-legal-${link?.label}`}>
                  <Link
                    href={link?.href}
                    className="text-sm text-white/70 hover:text-white transition-colors duration-150"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            © 2026 USA Peptide Pros. All rights reserved.
          </p>
          <p className="text-xs text-white/30 text-center sm:text-right">
            Content is for research and informational purposes only. Not medical advice.
          </p>
        </div>
      </div>
    </footer>
  );
}